module.exports = __webpack_public_path__ + "static/img/right-resting-hand.139ec2d2.webp";